import { useState } from 'react';
import { useTheme } from 'styled-components';

import loopLogo from '../assets/svg/loop-optimise-logo-white.svg';

interface ThemeAwareLogoProps {
  stacked?: boolean;
  alt?: string;
  className?: string;
}

const ThemeAwareLogo = ({ stacked = false, alt = 'Company Logo', className = '' }: ThemeAwareLogoProps) => {
  const theme = useTheme();
  const [imgError, setImgError] = useState(false);

  // logo path, default to loop logo otherwise (unsure with whitelabel)
  const logoPath = theme.navbar?.logoPath || '/images/loop-optimise-logo-white.svg';

  // Determine which logo to use based on the stacked prop
  const defaultLogo = loopLogo;

  const logoSrc = !imgError && logoPath.startsWith('/') ? process.env.PUBLIC_URL + logoPath : defaultLogo;

  // On error revert to a default if needed? (unsure if there is one for white label)
  const handleError = () => {
    if (!imgError) {
      console.warn(`Failed to load logo from path: ${logoPath}, falling back to default logo`);
      setImgError(true);
    }
  };

  return <img src={logoSrc} alt={alt} className={className} onError={handleError} />;
};

export default ThemeAwareLogo;
